<div class="flex flex-column align-items-center justify-content-center p-5 gap-3">
  @if (status() === 'error') {
    <p-message
      severity="error"
      icon="fa-solid fa-circle-exclamation"
    >
      {{ errorKey() | translate }}
    </p-message>
  } @else {
    <p-progress-spinner
      ariaLabel="loading"
      class="w-2rem h-2rem"
    />
    <p>
      {{
        (status() === 'redirecting' ? 'printerAuthRedirecting' : 'printerAuthConnecting')
          | translate
      }}
    </p>
  }
</div>
